<template>
  <!-- 目前未对secondField和secondProject同时出现的情况做处理 -->
  <div>
    <div class="table">
        <div class="table-color-block">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
        <div class="elTable">
            <el-table
                stripe
                :span-method="arraySpanMethod"
                :data="tableData"
                :row-style="{height:rowHeight}"
                :cell-style="tableCellStyle"
                :header-cell-style="tableHeaderCellStyle"
                border>
                <el-table-column
                    prop="index"
                    width="74px"
                    align="center"
                    :resizable="false"
                    >
                    <template v-slot:header>
                        <div class="table-title table-col1-color-font">序号</div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="field"
                    align="center"
                    :resizable="false"
                    :class-name="hasSecondFieldColumn?'fieldColumn':''"
                    :width="hasSecondFieldColumn?'80px':'135px'">
                    <template v-slot:header>
                        <div class="table-title table-col2-color-font">{{fieldColumnName}}</div>
                    </template>
                    <template slot-scope="scope">
                        <div class="field">{{scope.row.field}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    v-if="hasSecondFieldColumn"
                    prop="secondField"
                    align="center"
                    width="55px"
                    :class-name="hasSecondFieldColumn?'secondFieldColumn':''"
                    :resizable="false">
                    <template v-slot:header>
                        <div class="table-title table-col2-color-font">{{secondFieldColumnName}}</div>
                    </template>
                    <template slot-scope="scope">
                        <div class="secondField">{{scope.row.secondField}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    v-if="hasSecondProjectColumn"
                    prop="secondProject"
                    align="center"
                    width="123px"
                    :resizable="false">
                </el-table-column>
                <el-table-column
                    prop="project"
                    align="center"
                    :resizable="false"
                    :class-name="hasSecondProjectColumn?'projectColunm':''"
                    :width="hasSecondProjectColumn?'258px':'381px'">
                    <template v-slot:header>
                        <div class="table-title table-col3-color-font">试验项目</div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="period"
                    align="center"
                    :resizable="false"
                    width="129px">
                    <template v-slot:header>
                        <div class="table-title table-col4-color-font">{{periodColumnName}}</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cusTable',
  props: {
    tableData:{
        default: () => [],
        type: Array
    },
    rowHeight:{
        default: "",
        type: String
    },
    fieldColumnName:{
        default: "试验领域",
        type: String
    },
    secondFieldColumnName:{
        default: "域",
        type: String
    },
    periodColumnName:{
        default: "试验周期（月）",
        type: String
    }
  },
  data () {
    return {
        hasSecondProjectColumn: false,
        hasSecondFieldColumn: false
    }
  },
  computed: {
    rowIndexSpanCol1(){
        return this.getTableDataRepeat(this.tableData,'field')
    },
    rowIndexSpanCol2(){
        return this.getTableDataRepeat(this.tableData,'secondProject')
    },
    rowIndexSpanCol3(){
        return this.getTableDataRepeat(this.tableData,'secondField')
    },
  },
  watch: {
    'tableData':{
        handler(newVal,oldVal){
            let hasSecondProjectColumnFlag = false
            let hasSecondFieldColumnFlag = false
            newVal.forEach(item => {
                if(item.secondProject) hasSecondProjectColumnFlag = true
                if(item.secondField) hasSecondFieldColumnFlag = true
            })
            this.hasSecondProjectColumn = hasSecondProjectColumnFlag
            this.hasSecondFieldColumn = hasSecondFieldColumnFlag
        },
        immediate: true
    }
  },
  methods: {
    getTableDataRepeat(tableData,fieldName) {
        let arr =[] 
        let j=0
        for (let i=0;i<tableData.length;i++){
            if (i==0){
                arr.push(0)
            }else if (tableData[i][fieldName]==tableData[j][fieldName]){
                j++
            }else if (tableData[i][fieldName]!=tableData[j][fieldName]){
                arr.push(i)
                j++
            }
        }
        return arr
    },
    // 修改 table cell
    tableCellStyle(cell) {
        if(cell.columnIndex == 1){
            return "border-color: #b8b8b8;background-color: rgb(250, 250, 250);"
        }
        if(cell.columnIndex == 2 && this.hasSecondProjectColumn){
            return "border-color: #b8b8b8;background-color: rgb(255, 255, 255);"
        }
        if(cell.columnIndex == 2 && this.hasSecondFieldColumn){
            return "border-color: #b8b8b8;background-color: rgb(255, 255, 255);padding: 0 10px !important;"
        }
        return "border-color: #b8b8b8;"
    },
    // 修改 table header cell
    tableHeaderCellStyle(header) {
        if(header.columnIndex == 2 && this.hasSecondProjectColumn){
            return "border-color: #b8b8b8;border-right: none;"
        }
        if(header.columnIndex == 1 && this.hasSecondFieldColumn){
            return "border-color: #b8b8b8;border-right: none;"
        }
        return 'border-color: #b8b8b8;'
    },
    // 控制表格的合并
    // 当前行row、当前列column、当前行号rowIndex、当前列号columnIndex
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 1) {
            // if (rowIndex===0) { // 用于设置合并开始的行号
            //     return {
            //         rowspan: 4, //合并的行数
            //         colspan: 1 //合并的列数，设为０则直接不显示
            //     };
            // }else if (rowIndex===4) { 
            //     return {
            //         rowspan: 22, 
            //         colspan: 1 
            //     };
            // }else if (rowIndex===26) { 
            //     return {
            //         rowspan: 7, 
            //         colspan: 1 
            //     };
            // }else{
            //     return {
            //         rowspan: 0, 
            //         colspan: 0 
            //     };
            // }
            if (this.rowIndexSpanCol1.includes(rowIndex) && rowIndex!=this.rowIndexSpanCol1[this.rowIndexSpanCol1.length-1]) { // 用于设置合并开始的行号
                return {
                    rowspan: this.rowIndexSpanCol1[this.rowIndexSpanCol1.indexOf(rowIndex)+1] - this.rowIndexSpanCol1[this.rowIndexSpanCol1.indexOf(rowIndex)], //合并的行数
                    colspan: 1 //合并的列数，设为０则直接不显示
                };
            }else if(rowIndex==this.rowIndexSpanCol1[this.rowIndexSpanCol1.length-1]){
                return {
                    rowspan: this.tableData.length - this.rowIndexSpanCol1[this.rowIndexSpanCol1.indexOf(rowIndex)], //合并的行数
                    colspan: 1 //合并的列数，设为０则直接不显示
                };
            }else{
                return {
                    rowspan: 0, 
                    colspan: 0 
                };
            }
        }
        if (columnIndex === 2 && this.hasSecondFieldColumn){
            if (this.rowIndexSpanCol3.includes(rowIndex) && rowIndex!=this.rowIndexSpanCol3[this.rowIndexSpanCol3.length-1]) { // 用于设置合并开始的行号
                if(row.secondProject==''){
                        return {
                        rowspan: 0, 
                        colspan: 0 
                    };
                }else{
                    return {
                        rowspan: this.rowIndexSpanCol3[this.rowIndexSpanCol3.indexOf(rowIndex)+1] - this.rowIndexSpanCol3[this.rowIndexSpanCol3.indexOf(rowIndex)], //合并的行数
                        colspan: 1 //合并的列数，设为０则直接不显示
                    };
                }
            }else if(rowIndex==this.rowIndexSpanCol3[this.rowIndexSpanCol3.length-1]){
                if(row.secondProject==''){
                        return {
                        rowspan: 0, 
                        colspan: 0 
                    };
                }else{
                    return {
                        rowspan: this.tableData.length - this.rowIndexSpanCol3[this.rowIndexSpanCol3.indexOf(rowIndex)], //合并的行数
                        colspan: 1 //合并的列数，设为０则直接不显示
                    };
                }
            }else{
                return {
                    rowspan: 0, 
                    colspan: 0 
                };
            }
        }
        if (columnIndex === 2 && this.hasSecondProjectColumn){
            if (this.rowIndexSpanCol2.includes(rowIndex) && rowIndex!=this.rowIndexSpanCol2[this.rowIndexSpanCol2.length-1]) { // 用于设置合并开始的行号
                if(row.secondProject==''){
                        return {
                        rowspan: 0, 
                        colspan: 0 
                    };
                }else{
                    return {
                        rowspan: this.rowIndexSpanCol2[this.rowIndexSpanCol2.indexOf(rowIndex)+1] - this.rowIndexSpanCol2[this.rowIndexSpanCol2.indexOf(rowIndex)], //合并的行数
                        colspan: 1 //合并的列数，设为０则直接不显示
                    };
                }
            }else if(rowIndex==this.rowIndexSpanCol2[this.rowIndexSpanCol2.length-1]){
                if(row.secondProject==''){
                        return {
                        rowspan: 0, 
                        colspan: 0 
                    };
                }else{
                    return {
                        rowspan: this.tableData.length - this.rowIndexSpanCol2[this.rowIndexSpanCol2.indexOf(rowIndex)], //合并的行数
                        colspan: 1 //合并的列数，设为０则直接不显示
                    };
                }
            }else{
                return {
                    rowspan: 0, 
                    colspan: 0 
                };
            }
        }
        if(columnIndex === 3 && this.hasSecondProjectColumn){
            if (row.secondProject=='') { 
                return {
                    rowspan: 1, //合并的行数
                    colspan: 2 //合并的列数
                };
            }
        }
    },
  },
}
</script> 

<style lang='less' scoped>
    .table{
        @table-col1-color:#F4B92E;
        @table-col2-color:#333333;
        @table-col3-color:#DB0000;
        @table-col4-color:#008BFD;
        @border-color:#b8b8b8;
        .table-color-block{
            display: flex;
            div{
                height: 10px;
                box-sizing: border-box;
                border-left: 1px solid @border-color;
                border-top: 1px solid @border-color;
            }
            div:nth-child(1){
                width: 74px;
                background-color: @table-col1-color;
            }
            div:nth-child(2){
                width: 135px;
                background-color: @table-col2-color;
            }
            div:nth-child(3){
                width: 381px;
                background-color: @table-col3-color;
            }
            div:nth-child(4){
                width: 130px;
                border-right: 1px solid @border-color;
                background-color: @table-col4-color;
            }
        }
        .elTable{
            /deep/ .el-table{
                border-color: @border-color;
                &::after {
                    display: none;
                }
                &::before{
                    // display: none;
                }
                th{
                    padding: 0 !important;
                    .cell{
                        padding: 0 !important;
                    }
                }
                .el-table__cell{
                    padding-top: 6px !important;
                    padding-bottom: 6px !important;
                }
                .el-table__body-wrapper{
                    border-bottom: 1px solid @border-color;
                }
                //禁止鼠标移入高亮
                //这种方法将导致表格的点击事件无法使用，例如表格最后一列的一些弹窗、或者一些删除、修改或者添加等操作将无法使用！！！
                tbody tr {
                    // pointer-events: none;
                }
                th[class*="projectColunm"]{
                    div{
                        text-align: left;
                        // padding-left: 85px;
                    }
                }
                th[class*="fieldColumn"]{
                    div{
                        text-align: right;
                    }
                }
                th[class*="secondFieldColumn"]{
                    div{
                        text-align: left;
                    }
                }
            }
            .table-title{
                box-sizing: border-box;
                height: 48px;
                line-height: 48px;
                text-align: center;
                font-size: 16px;
                font-weight: bold;
            }
            .table-col1-color-font{
                color: @table-col1-color;
            }
            .table-col2-color-font{
                color: @table-col2-color;
            }
            .table-col3-color-font{
                color: @table-col3-color;
            }
            .table-col4-color-font{
                color: @table-col4-color;
            }
            .field{
                width: 12px;
                font-size: 20px;
                line-height: 24px;
                position: relative;
                color: #333333;
                left: 50%;
                transform: translateX(-50%);
                font-weight: bold;
            }
            .secondField{
                font-size: 14px;
                font-weight: bold;
                color: #333333;
                line-height: 17px;
            }
        }
    }
</style>
